/* AM-CART — Aviso de reserva (temporizador de urgencia en el carrito lateral).

   Calca el aviso de maison-moda.com: una barra rosada arriba del carrito con un
   contador que baja desde 15:00. Se inyecta en el Shadow DOM ABIERTO de #amCart
   (creado por am-cart.js), por eso no hay que tocar ese archivo.

   Texto y minutos vienen del bloque "reserva" de la config JSON #am-cart-config. */

(function () {
  'use strict';

  function leerConfig() {
    var def = {
      activo: true,
      minutos: 15,
      texto: '¡Tus productos están reservados por los próximos {t} minutos!'
    };
    var el = document.getElementById('am-cart-config');
    if (!el) return def;
    try {
      var c = JSON.parse(el.textContent).reserva;
      if (!c) return def;
      return {
        activo: c.activo !== false,
        minutos: c.minutos || def.minutos,
        texto: c.texto || def.texto
      };
    } catch (e) { return def; }
  }

  var CFG = leerConfig();
  if (!CFG.activo) return;

  var KEY = 'am_reserva_deadline';

  var CSS =
    '.am-reserva{background:#ede9e5;color:#111111;text-align:center;' +
    'font-size:12.5px;line-height:1.25;font-weight:400;padding:7px 20px;' +
    'border-bottom:1px solid rgba(0,0,0,.06);}' +
    '.am-reserva strong{font-weight:700;white-space:nowrap;}';

  /* MM:SS a partir de milisegundos */
  function reloj(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var m = Math.floor(s / 60), r = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
  }

  /* HTML del aviso: en negrita SOLO el tiempo y la palabra "minutos". */
  function textoHTML(ms) {
    var s = CFG.texto.replace('{t}', '<strong>' + reloj(ms) + '</strong>');
    return s.replace(/minutos/i, '<strong>$&</strong>');
  }

  /* Fecha límite persistida en localStorage: así el contador NO se reinicia al
     recargar la página ni al cerrar y reabrir el carrito. Si ya venció, arranca de nuevo. */
  function limite() {
    var now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (!dl || dl <= now) {
      dl = now + CFG.minutos * 60000;
      try { localStorage.setItem(KEY, String(dl)); } catch (e) {}
    }
    return dl;
  }

  function tick() {
    var host = document.getElementById('amCart');
    var root = host && host.shadowRoot;
    if (!root) return;
    var body = root.querySelector('.body');
    if (!body) return;

    var banner = root.querySelector('.am-reserva');
    if (!banner) {
      var st = document.createElement('style');
      st.textContent = CSS;
      root.appendChild(st);
      banner = document.createElement('div');
      banner.className = 'am-reserva';
      body.insertBefore(banner, body.firstChild);
    }

    /* Cantidad REAL del carrito. OJO: los .item del drawer solo existen cuando el
       carrito está ABIERTO; tras recargar la página el drawer está cerrado y no hay
       ninguno, así que contarlos hacía creer que el carrito estaba vacío y borraba
       la fecha límite (el contador se reiniciaba a 15:00 en cada recarga). */
    var cart = (window.amCart && typeof window.amCart.estado === 'function') ? window.amCart.estado() : null;
    var count = cart ? (cart.item_count || 0) : null;

    if (count === 0) {
      /* Carrito realmente vacío: ocultar y reiniciar para el próximo carrito. */
      banner.style.display = 'none';
      try { localStorage.removeItem(KEY); } catch (e) {}
      return;
    }

    if (count === null) {
      /* Aún no sabemos (el carrito no ha cargado): NO borrar la fecha límite.
         Mostrar solo si el drawer ya está abierto con artículos. */
      var abiertoConItems = !!root.querySelector('.item');
      banner.style.display = abiertoConItems ? '' : 'none';
      if (abiertoConItems) {
        banner.innerHTML = textoHTML(limite() - Date.now());
      }
      return;
    }

    /* count > 0: hay productos en el carrito (aunque el drawer esté cerrado). */
    banner.style.display = '';
    banner.innerHTML = textoHTML(limite() - Date.now());
  }

  setInterval(tick, 1000);
  tick();
})();
